/**
 * External dependencies
 */
/**
 * Internal dependencies
 */
import { makeLayout, render } from "lib/controller";
import { dashboard } from "./controller";
import { navigation } from "./controller";

export default (router) => {
  router(`/`, navigation, dashboard, makeLayout, render);
  router(`/decks`, navigation, dashboard, makeLayout, render);
  router(`/decks/:dashboardId`, navigation, dashboard, makeLayout, render);
};
